<div class="oris-breadcrumb  layout-breadcrumb-container p-d-flex p-ai-center p-jc-sm-start p-j-search-area" *ngIf="appMain.isMobile()">
    <div class="layout-breadcrumb-right-items p-d-flex">
        <app-topbar></app-topbar>
    </div>
    
    <div class="layout-breadcrumb-container p-d-flex p-ai-center p-jc-between p-j-title-subtitle-area" style="width: 100%;">
        <p-breadcrumb [model]="items" styleClass="layout-breadcrumb p-py-2"></p-breadcrumb>
        <div class="layout-breadcrumb-center-label" *ngIf="centerLabel">{{centerLabel}}</div>
        <div class="layout-breadcrumb-right-items mr-2 p-d-flex">
            <p-dropdown [dropdownIcon]="'none'" [options]="languages" [(ngModel)]="language" (onChange)="changeLanguage($event)" optionLabel="name" [showClear]="false">
                <ng-template pTemplate="selectedItem">
                    <div class="lang-item lang-item-value"  *ngIf="language">
                    <img class="oris-lang-img" src="../../../assets/images/icons/translate.png"/>
                        <!-- <div class="lang-name">{{language.name}}</div> -->
                    </div>
                </ng-template>
                <ng-template let-lang pTemplate="item">
                    <div class="lang-item">
                        <img src="{{lang.flag}}" [class]="'flag flag-' + lang.code.toLowerCase()" />
                        <div class="lang-name">{{lang.name}}</div>
                    </div>
                </ng-template>
            </p-dropdown>
        </div>
    </div>
</div>

<div class="oris-breadcrumb layout-breadcrumb-container p-d-flex p-ai-center p-jc-between p-j-title-subtitle-area" *ngIf="!appMain.isMobile()">
    <div class="layout-breadcrumb-left-items p-d-flex p-ai-center">

        <a href="#" class="app-name">
            <img alt="orisdent-menu-logo-img" width="40" height="40" src="../assets/layout/images/logo-dark.svg"/>
        </a>
        <p-breadcrumb [model]="items" styleClass="layout-breadcrumb p-py-2">
        </p-breadcrumb>
    </div>
    <div class="layout-breadcrumb-center-label" *ngIf="centerLabel">{{centerLabel}}</div>
    <div class="layout-breadcrumb-right-items p-mr-6">
        <p-dropdown [dropdownIcon]="'none'" [options]="languages" [(ngModel)]="language" (onChange)="changeLanguage($event)" optionLabel="name" [showClear]="false">
            <ng-template pTemplate="selectedItem">
                <div class="lang-item lang-item-value"  *ngIf="language">
                    <img class="oris-lang-img" src="../../../assets/images/icons/translate.png"/>
                    <!-- <div class="lang-name">{{language.name}}</div> -->
                </div>
            </ng-template>
            <ng-template let-lang pTemplate="item">
                <div class="lang-item">
                    <img src="{{lang.flag}}" style="border-radius: 4px;" [class]="'flag flag-' + lang.code.toLowerCase()" />
                    <div class="lang-name">{{lang.name}}</div>
                </div>
            </ng-template>
        </p-dropdown>
    </div>
</div>
